import React from "react";
import { Grid } from "@mui/material";
import './cardStyle.css'

const DashboardCard = (props) => {
  return (
        <Grid
            xs={12}
            sm={6}
            className="mt-4" 
        >
            <div className="px-3">
                <div className="p-3" >
                    <div className="MS---dapp_metaBalance p-4 mx-auto">
                        <h4 className="text-uppercase px-lg-4">{props.title}</h4>
                        <h4 className="text-center text-light mt-2 mb-0">
                            {props.detailstitle} {props.details}
                        </h4>
                    </div>
                </div>
            </div>
        </Grid>
  );
}

export default DashboardCard;
